import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAdsInventoryList, useAdsCampaign } from "api/banner/hooks";
import { trackEvent } from "utils/analytics";

const WingBanner = ({ name }) => {
  /*-----------------광고-----------------*/
  /* 광고 데이터  
  
  1. 페이지
  domain: moreden
  page :    
  route: /*
  pageId: 83
  device: pc

  2. inventory 목록
   - 10 : pc_all_wing_left_top (160 x 300)
   - 11 : pc_all_wing_left_middle (160 x 120)
   - 12 : pc_all_wing_left_bottom (160 x 120)
   - 13 : pc_all_wing_right_middle (160 x 120)
   - 14 : pc_all_wing_right_bottom (160 x 300)
   - 15 : pc_all_wing_right_top  (160 x 300)
  
  */
  const defaultAd = {
    segment: {},
    link: "",
    advertisementFile: { formats: {}, url: "" },
  };

  const [ads, setAds] = useState({ ...defaultAd });

  const { data: adsInventoryList, isLoading: adsInventoryLoading } = useAdsInventoryList({
    pageName: "all",
  });
  const { data: adsCampaign, isLoading: adsCampaginLoading } = useAdsCampaign({
    name,
    adsInventoryList,
    pageName: "all",
  });

  /*-----------------광고끝-----------------*/

  useEffect(() => {
    if ((adsCampaign || []).length > 0) {
      const selectedAds = adsCampaign[getRandomInt(0, adsCampaign.length)];
      // console.log("selected", name, selectedAds);
      setAds(selectedAds);
      trackEvent("Ads Viewed", selectedAds.segment);
    }
  }, [adsCampaign]);
  const getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
  };
  // const target = ads[name];

  const {
    inventoryWidth: width,
    inventoryHeight: height,
    segment,
    link,
    advertisementFile: { formats, url },
  } = ads;
  const bannerClicked = () => {
    if (!segment) return;
    window.analytics.track("Ads Clicked", segment);
  };

  if (!ads.campaignId) return null;
  // console.log("ads", ads, width, height, url, link, segment);

  return (
    <Link to={link} onClick={bannerClicked}>
      <img
        src={url}
        style={{
          objectFit: "cover",
          width: `${width}px`,
          minHeight: `${height}px`,
          objectPosition: "center top",
        }}
      />
    </Link>
  );
};

export default WingBanner;
